export default {"src":"/_next/static/media/gdpr.98a825f7.svg","height":41,"width":40};